export const projectExpressionServicios: string[] = [
  'id',
  'nombreServicio',
  'isDeleted',
  'editOperation',
  'newTotalCostoDolares',
  'newTotalCostoSoles',
  'totalCostoSoles',
  'totalCostoDolares',
  'paxQuantity',
  'lstPaX.estado',
  'tipoServicio',
  'paxTickets.ticketAdulto',
  'paxTickets.ticketNacional',
  'paxTickets.ticketEstudiante',
  'paxTickets.ticketNino',
];

export const projectionExpressionTickets = [
  'id',
  'idService',
  'paxTickets.ticketAdulto',
  'paxTickets.ticketNacional',
  'paxTickets.ticketEstudiante',
  'paxTickets.ticketNino',
];

export const ProveddoresProjectExpression = [
  'id',
  'nombre',
  'direccionLegal',
  'estadoProveedor',
];
